import { Flex } from "~/components/Flex";

export type ListCountChipProps = {
  count: number;
  max?: number;
};

export function ListCountChip({ count, max = 99 }: ListCountChipProps) {
  const text = count <= max ? `${count}` : `${max}+`;
  return (
    <Flex
      children={text}
      sx={{
        bgcolor: "warning.main",
        color: "common.black",
        fontSize: 12,
        fontWeight: 500,
        height: 20,
        width: 20,
        borderRadius: "50%",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
  );
}
